export const baseUrl = 'http://admin.bloomsho.com/';
export const baseUrlAPI = 'http://app.bloomsho.com/api';
